var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('img',{attrs:{"src":require("@/assets/wineBox/left-arrow.svg"),"alt":"Voltar"},on:{"click":_vm.toggleWineBox}}),_c('p',[_vm._v("WineBox ("+_vm._s(_vm.carrinho.length)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }